import qs from 'qs';
/**
 * Helper function for the Custom Select component
 * @param  {string} label The label/value of the option
 * @return {object}       The option in the correct format
 */
export const createOption = (label, value) => {
    if (value === undefined) {
        value = label;
    }
    return {
        label,
        value
    };
};


export const fetchApiCall = async ({
    endPoint,
    request = null,
    method,
    dispatch,
    auth,
    type,
    data
}) => {
    if (!(await auth.isAuthenticated())) {
        auth.login('/');
        return false;
    }

    const queryString = qs.stringify(request);
    console.log("aaa....."+queryString);
    //endPoint = `${endPoint}${(queryString ? `?${queryString}` : "")}`;

    dispatch({
        type,
        payload : {
            [type] : {
                [method] : true
            }
        }
    });

    const fetchMethod = method.split("_")[0];
   
    const fetchObj = {
        headers : {
           // Authorization : "HVdwZc/ZwYoJwZuqBuVHVHMCnJSvcxl4WrQgx2jU",
            Authorization  : 'Bearer ' + await auth.getAccessToken(),
            "Content-Type" : "application/json; charset=utf-8",
            "x-api-key"    : process.env.REACT_APP_FILE_UPLOAD_X_API_KEY
        },
        method : fetchMethod
    };
    if (fetchMethod === "POST") {
        if (data) {
            fetchObj["body"] = JSON.stringify(data);
        }
    }

    return fetch(endPoint, fetchObj).then(res => {
        
        dispatch({
            type,
            payload : {
                [type] : {
                    [method] : false
                }
            }
        });

        if (res.status >= 400) {
            if (res.status === 401) {
                auth.login('/');
            } else {
                throw new Error(`API call failed (Status: ${res.status} , ${res.statusText})`);
            }
        }

        return res;
    }).catch(err => {
        dispatch({
            type,
            payload : {
                [type] : {
                    [method] : false
                }
            }
        });
        
        throw err;
    });
};
